import { Component, ElementRef } from '@angular/core';
import { BasePersistentNotification } from '@components/base-persistent-notification';
import { TranslateService } from '@ngx-translate/core';
import { Invite, ValidationError } from '@queries/generated';
import { CurrentUserService } from '@services/current-user.service';
import { GrantsService } from '@services/grants.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'vnm-invite-notification',
  templateUrl: './invite-notification.component.html',
  styleUrls: ['./invite-notification.component.scss']
})
export class InviteNotificationComponent extends BasePersistentNotification {
  errors: ValidationError[];
  showInvite = false;
  submitted = false;

  constructor(
    private translateService: TranslateService,
    private userService: CurrentUserService,
    private grantService: GrantsService,
    private messageService: MessageService,
    el: ElementRef
  ) {
    super(el);
  }

  toggleInvite() {
    this.showInvite = !this.showInvite;
  }

  onHandleInvite(event: Event, accepted: boolean) {
    event.stopPropagation();
    this.submitted = true;

    const inviteRec = this.record as unknown as Invite;
    const input = { id: inviteRec.id, accepted };

    this.userService.handleInvite(input).subscribe(
      (invite) => {
        const hasAccepted = invite.status === 'accepted';
        const severity = hasAccepted ? 'success' : 'warn';
        this.messageService.add({
          severity: severity,
          summary: this.translateService.instant(`handle-invite.${invite.status}-summary`),
          detail: this.translateService.instant(`handle-invite.${invite.status}-detail`, { course: invite.name })
        });

        if (hasAccepted) {
          this.grantService.refresh();
          this.userService.refresh();
        }
        this.showInvite = false;
      },
      (errors) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant(`handle-invite.${inviteRec.status}-summary`),
          detail: this.translateService.instant(`handle-invite.${inviteRec.status}-detail`, { course: inviteRec.name })
        });

        this.submitted = false;
        this.errors = errors;
        this.showInvite = true;
      }
    );
  }
}
